// extracted by mini-css-extract-plugin
export default {"requirements":"requirements--JYi3E","title":"title--erwC6"};